import Navbar from './Navbar';
import Footer from './Footer';
import CookieConsentBanner from './CookieConsentBanner';
import { Providers } from './Providers';

/**
 * Gemeinsame Seitenhuelle: Navigation, Inhalt, Cookie-Hinweis, Fuss.
 *
 * Hiess frueher RootLayout und lag unter app/layout.js - was aussah wie ein
 * Next.js App Router, aber keiner war (es fehlte eine page.js). Jede Seite
 * importierte die Datei von Hand als gewoehnliche Komponente. Neuer Name und
 * neuer Ort machen deutlich, was es wirklich ist.
 */
export default function SiteLayout({ children }) {
  return (
    <Providers>
      <Navbar />
      <main className="flex min-h-screen flex-col items-center justify-between text-primary">
        {children}
      </main>
      <CookieConsentBanner />
      <Footer />
    </Providers>
  );
}
